<div class="step-title">
  <button matIconButton type="button" aria-label="Indietro" (click)="flow.back()">
    <i class="fa-regular fa-arrow-left" aria-hidden="true"></i>
  </button>
  <span class="title-medium-emphasized">Crea manualmente</span>
</div>

<form class="step-fields" [formGroup]="form" (ngSubmit)="valid && continue()">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Ragione sociale *</mat-label>
    <input matInput formControlName="ragioneSociale" maxlength="35">
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Codice fiscale *</mat-label>
    <input matInput formControlName="codiceFiscale" maxlength="16" autocapitalize="characters" spellcheck="false">
    @if (form.controls.codiceFiscale.hasError('taxCode')) {
      <mat-error>Il codice fiscale deve essere composto da 16 caratteri alfanumerici oppure 11 numerici</mat-error>
    } @else {
      <mat-hint>16 caratteri alfanumerici oppure 11 caratteri solo numerici</mat-hint>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Partita IVA *</mat-label>
    <input matInput formControlName="partitaIva" inputmode="numeric" maxlength="11" spellcheck="false">
    <mat-hint>11 caratteri solo numerici</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Indirizzo *</mat-label>
    <input matInput formControlName="indirizzo" maxlength="35">
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Località *</mat-label>
    <input matInput formControlName="comune" maxlength="60">
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Provincia *</mat-label>
    <input matInput formControlName="provincia" maxlength="2" autocapitalize="characters" spellcheck="false">
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>CAP *</mat-label>
    <input matInput formControlName="cap" inputmode="numeric" maxlength="5">
  </mat-form-field>

  <mat-checkbox formControlName="useAsDelivery">Usa questo indirizzo come destino di consegna</mat-checkbox>
</form>

<div class="step-actions">
  <button matButton="filled" type="button" [disabled]="!valid" (click)="continue()">Prosegui</button>
</div>
